import { Button, Modal } from '@ver-uds/react';
import { Alert } from '@ver-uds/uswds-react';

import React from 'react';
import I9Constants from '../I9Constants/I9Constants';

export type EVerifyPlusSuccessModalProps = {
  isOpen: boolean;
  close(): void;
  evePlusEnabled: boolean;
};

const EVerifyPlusSuccessModal = ({ isOpen, close, evePlusEnabled }: EVerifyPlusSuccessModalProps): JSX.Element => {
  const modalId = 'everify-plus-success-modal';

  const root = document.createElement('div');
  root.id = 'root';
  document.body.appendChild(root);
  Modal.setAppElement('#root');

  const handleClose = (): void => {
    close();
  };

  return (
    <Modal
      id={modalId}
      header={`${I9Constants.PROGRAM_NAME} has been enabled for your account.`}
      open={isOpen}
      close={handleClose}
      hasDismissButton={false}
      fixedToTop
    >
      <Modal.Content>
        {evePlusEnabled && (
          <Alert status="warning" slim>
            <Alert.Text>Another Program Administrator has already enabled {I9Constants.PROGRAM_NAME}.</Alert.Text>
          </Alert>
        )}
        <Alert status="info">
          <Alert.Text>
            Any users currently online will now be redirected from their active sessions to complete the training. All
            other users will be prompted to complete the video training at their next sign-in. Note: All users must
            complete the video training prior to regaining access and use of E-Verify.
          </Alert.Text>
        </Alert>
      </Modal.Content>
      <Modal.Footer>
        <Button
          type="button"
          variant="primary"
          onClick={handleClose}
          aria-label={`Continue to ${I9Constants.PROGRAM_NAME} Training`}
          data-close-modal
        >
          Continue to {I9Constants.PROGRAM_NAME} Training
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default EVerifyPlusSuccessModal;
